
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gameResults",
      function () {
        return require("private-next-pages/gameResults.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gameResults"])
      });
    }
  